import React from 'react'

export default function HighlightedText({ text, terms }) {
  if (!text || !terms || terms.length === 0) {
    return <>{text}</>
  }

  const pattern = new RegExp(`(${terms.map(t => t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')})`, 'gi')
  const parts = text.split(pattern)

  return (
    <>
      {parts.map((part, i) => {
        const isMatch = terms.some(term =>
          part.toLowerCase() === term.toLowerCase()
        )
        return isMatch ? (
          <mark key={i} className="command-highlight">
            {part}
          </mark>
        ) : (
          <React.Fragment key={i}>{part}</React.Fragment>
        )
      })}
    </>
  )
}
